import { useSelector } from 'react-redux';

import { RootState } from '@/redux/store';

export const useMLFulfillAccess = () => {
  const { mlFulfillAccess } = useSelector((state: RootState) => state.parcel);

  return {
    hasMLFulfillAccess: mlFulfillAccess.hasAccess,
    checked: mlFulfillAccess.checked,
  };
};
